import styled from "styled-components";
import SistemaFixedModal from "~/componentes/Modal/Styleds/SistemaFixedModal";
import { Colors } from "~/config/Colors";

export const Container = styled(SistemaFixedModal)`
  padding: 1rem;
  width: fit-content;
  height: fit-content;
  box-shadow: 0px 0px 19px 0px rgb(4 4 4 / 25%) !important;
  z-index: 99;

  .confirmacaoHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-select {
      border-radius: 0.4rem;
      padding: 0.15rem 0.8rem 0.15rem 0.5rem;
      background: ${Colors.Color2};

      p {
        color: ${Colors.Color4};
        font-size: 0.8125rem;
        font-weight: 800;
      }
    }
  }

  .confirmacaoBody {
    position: relative;
    background: ${Colors.Color2};
    border-radius: 0.5rem;
    margin: 1rem 0rem;
    padding: 1.5rem 2rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    span.select {
      position: absolute;
      top: 15%;
      left: 0rem;
      background: ${Colors.Color4};
      width: 0.25rem;
      height: 70%;
      border-radius: 1rem;
    }

    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: ${Colors.Color7};

      i {
        font-size: 0.85rem;
      }

      p {
        font-size: 0.85rem;
        font-weight: 800;
        line-height: normal;
        margin-left: 0.2rem;
      }
    }

    .message {
      color: ${Colors.Color7};
      font-size: 0.95rem;
      font-weight: 400;
      line-height: normal;
    }
  }

  .confirmacaoBotoes {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    button {
      margin: 0em 0 0em 1rem;

      .loadingIcon {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        animation: loading 2s linear infinite;
      }

      @keyframes loading {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }
`;
